import { OP, STATUS } from "../../constant";

const INITIAL_STATE = {
  // ------ Account initial-------- //
  accountListStatus: STATUS.DEFAULT,
  accountListResult: null,
  accountListErrormessage: "",

  viewAccountStatus: STATUS.DEFAULT,
  viewAccountResult: null,
  viewAccountErrorMessage: "",

  activateAccountStatus: STATUS.DEFAULT,
  activateAccountResult: null,
  activateAccountErrorMessage: "",

  deactivateAccountStatus: STATUS.DEFAULT,
  deactivateAccountResult: null,
  deactivateAccountErrorMessage: "",

  createAccountStatus: STATUS.DEFAULT,
  createAccountResult: null,
  createAccountErrorMessage: "",

  approveAccountStatus: STATUS.DEFAULT,
  approveAccountResult: null,
  approveAccountErrorMessage: "",

  rejectAccountStatus: STATUS.DEFAULT,
  rejectAccountResult: null,
  rejectAccountErrorMessage: "",

  viewAgentAccountStatus: STATUS.DEFAULT,
  viewAgentAccountResult: null,
  viewAgentAccountErrorMessage: "",

  getWakalaAccountDetailsStatus: STATUS.DEFAULT,
  getWakalaAccountDetailsResult: null,
  getWakalaAccountDetailsErrorMessage: "",
};

const accountsReducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    // *-------- > Account list reducers
    case OP.ACCOUNT_LIST_LOADING:
      return {
        ...state,
        accountListStatus: STATUS.LOADING,
      };
    case OP.ACCOUNT_LIST_SUCCESS:
      return {
        ...state,
        accountListStatus: STATUS.SUCCESS,
        accountListResult: payload,
        accountListErrorMessage: "",
      };
    case OP.ACCOUNT_LIST_FAILURE:
      return {
        ...state,
        accountListStatus: STATUS.ERROR,
        accountListResult: null,
        accountListErrorMessage: payload,
      };
    case OP.ACCOUNT_LIST_RESET:
      return {
        ...state,
        accountListStatus: STATUS.DEFAULT,
        accountListResult: null,
        accountListErrorMessage: "",
      };

    // *-------- > create account reducers
    case OP.CREATE_ACCOUNT_LOADING:
      return {
        ...state,
        createAccountStatus: STATUS.LOADING,
      };
    case OP.CREATE_ACCOUNT_SUCCESS:
      return {
        ...state,
        createAccountStatus: STATUS.SUCCESS,
        createAccountResult: payload,
        createAccountErrorMessage: "",
      };
    case OP.CREATE_ACCOUNT_FAILURE:
      return {
        ...state,
        createAccountStatus: STATUS.ERROR,
        createAccountResult: null,
        createAccountErrorMessage: payload,
      };
    case OP.CREATE_ACCOUNT_RESET:
      return {
        ...state,
        createAccountStatus: STATUS.DEFAULT,
        createAccountResult: null,
        createAccountErrorMessage: "",
      };

    // *-------- > view Account reducers
    case OP.VIEW_ACCOUNT_LOADING:
      return {
        ...state,
        viewAccountStatus: STATUS.LOADING,
      };
    case OP.VIEW_ACCOUNT_SUCCESS:
      return {
        ...state,
        viewAccountStatus: STATUS.SUCCESS,
        viewAccountResult: payload,
        viewAccountErrorMessage: "",
      };
    case OP.VIEW_ACCOUNT_FAILURE:
      return {
        ...state,
        viewAccountStatus: STATUS.ERROR,
        viewAccountResult: null,
        viewAccountErrorMessage: payload,
      };
    case OP.VIEW_ACCOUNT_RESET:
      return {
        ...state,
        viewAccountStatus: STATUS.DEFAULT,
        viewAccountResult: null,
        viewAccountErrorMessage: "",
      };

    // *-------- > activate account reducers
    case OP.ACTIVATE_ACCOUNT_LOADING:
      return {
        ...state,
        activateAccountStatus: STATUS.LOADING,
      };
    case OP.ACTIVATE_ACCOUNT_SUCCESS:
      return {
        ...state,
        activateAccountStatus: STATUS.SUCCESS,
        activateAccountResult: payload,
        activateAccountErrorMessage: "",
      };
    case OP.ACTIVATE_ACCOUNT_FAILURE:
      return {
        ...state,
        activateAccountStatus: STATUS.ERROR,
        activateAccountResult: null,
        activateAccountErrorMessage: payload,
      };
    case OP.ACTIVATE_ACCOUNT_RESET:
      return {
        ...state,
        activateAccountStatus: STATUS.DEFAULT,
        activateAccountResult: null,
        activateAccountErrorMessage: "",
      };

    // *-------- > deactivate Account reducers
    case OP.DEACTIVATE_ACCOUNT_LOADING:
      return {
        ...state,
        deactivateAccountStatus: STATUS.LOADING,
      };
    case OP.DEACTIVATE_ACCOUNT_SUCCESS:
      return {
        ...state,
        deactivateAccountStatus: STATUS.SUCCESS,
        deactivateAccountResult: payload,
        deactivateAccountErrorMessage: "",
      };
    case OP.DEACTIVATE_ACCOUNT_FAILURE:
      return {
        ...state,
        deactivateAccountStatus: STATUS.ERROR,
        deactivateAccountResult: null,
        deactivateAccountErrorMessage: payload,
      };
    case OP.DEACTIVATE_ACCOUNT_RESET:
      return {
        ...state,
        deactivateAccountStatus: STATUS.DEFAULT,
        deactivateAccountResult: null,
        deactivateAccountErrorMessage: "",
      };

    // *-------- >approve Account reducers
    case OP.APPROVE_ACCOUNT_LOADING:
      return {
        ...state,
        approveAccountStatus: STATUS.LOADING,
      };
    case OP.APPROVE_ACCOUNT_SUCCESS:
      return {
        ...state,
        approveAccountStatus: STATUS.SUCCESS,
        approveAccountResult: payload,
        approveAccountErrorMessage: "",
      };
    case OP.APPROVE_ACCOUNT_FAILURE:
      return {
        ...state,
        approveAccountStatus: STATUS.ERROR,
        approveAccountResult: null,
        approveAccountErrorMessage: payload,
      };
    case OP.APPROVE_ACCOUNT_RESET:
      return {
        ...state,
        approveAccountStatus: STATUS.DEFAULT,
        approveAccountResult: null,
        approveAccountErrorMessage: "",
      };

    // *-------- >reject account reducers
    case OP.REJECT_ACCOUNT_LOADING:
      return {
        ...state,
        rejectAccountStatus: STATUS.LOADING,
      };
    case OP.REJECT_ACCOUNT_SUCCESS:
      return {
        ...state,
        rejectAccountStatus: STATUS.SUCCESS,
        rejectAccountResult: payload,
        rejectAccountErrorMessage: "",
      };
    case OP.REJECT_ACCOUNT_FAILURE:
      return {
        ...state,
        rejectAccountStatus: STATUS.ERROR,
        rejectAccountResult: null,
        rejectAccountErrorMessage: payload,
      };
    case OP.REJECT_ACCOUNT_RESET:
      return {
        ...state,
        rejectAccountStatus: STATUS.DEFAULT,
        rejectAccountResult: null,
        rejectAccountErrorMessage: "",
      };

    // *-------- > create partner account reducers
    case OP.CREATE_PARTNER_ACCOUNT_LOADING:
      return {
        ...state,
        createPartnerAccountStatus: STATUS.LOADING,
      };
    case OP.CREATE_PARTNER_ACCOUNT_SUCCESS:
      return {
        ...state,
        createPartnerAccountStatus: STATUS.SUCCESS,
        createPartnerAccountResult: payload,
        createPartnerAccountErrorMessage: "",
      };
    case OP.CREATE_PARTNER_ACCOUNT_FAILURE:
      return {
        ...state,
        createPartnerAccountStatus: STATUS.ERROR,
        createPartnerAccountResult: null,
        createPartnerAccountErrorMessage: payload,
      };
    case OP.CREATE_PARTNER_ACCOUNT_RESET:
      return {
        ...state,
        createPartnerAccountStatus: STATUS.DEFAULT,
        createPartnerAccountResult: null,
        createPartnerAccountErrorMessage: "",
      };

    // *-------- > view agent Account reducers
    case OP.VIEW_AGENT_ACCOUNT_LOADING:
      return {
        ...state,
        viewAgentAccountStatus: STATUS.LOADING,
      };
    case OP.VIEW_AGENT_ACCOUNT_SUCCESS:
      return {
        ...state,
        viewAgentAccountStatus: STATUS.SUCCESS,
        viewAgentAccountResult: payload,
        viewAgentAccountErrorMessage: "",
      };
    case OP.VIEW_AGENT_ACCOUNT_FAILURE:
      return {
        ...state,
        viewAgentAccountStatus: STATUS.ERROR,
        viewAgentAccountResult: null,
        viewAgentAccountErrorMessage: payload,
      };
    case OP.VIEW_AGENT_ACCOUNT_RESET:
      return {
        ...state,
        viewAgentAccountStatus: STATUS.DEFAULT,
        viewAgentAccountResult: null,
        viewAgentAccountErrorMessage: "",
      };

    // *-------- > Get wakala account details reducers
    case OP.GET_WAKALA_ACCOUNT_DETAILS_LOADING:
      return {
        ...state,
        getWakalaAccountDetailsStatus: STATUS.LOADING,
      };
    case OP.GET_WAKALA_ACCOUNT_DETAILS_SUCCESS:
      return {
        ...state,
        getWakalaAccountDetailsStatus: STATUS.SUCCESS,
        getWakalaAccountDetailsResult: payload,
        getWakalaAccountDetailsErrorMessage: "",
      };
    case OP.GET_WAKALA_ACCOUNT_DETAILS_FAILURE:
      return {
        ...state,
        getWakalaAccountDetailsStatus: STATUS.ERROR,
        getWakalaAccountDetailsResult: null,
        getWakalaAccountDetailsErrorMessage: payload,
      };
    case OP.GET_WAKALA_ACCOUNT_DETAILS_RESET:
      return {
        ...state,
        getWakalaAccountDetailsStatus: STATUS.DEFAULT,
        getWakalaAccountDetailsResult: null,
        getWakalaAccountDetailsErrorMessage: "",
      };

    default:
      return state;
  }
};

export default accountsReducer;
